module.exports = __webpack_public_path__ + "img/listwa-pokrywy-bagaznika.92ef341b.jpg";